export default {
	"activate.Expired": "已过期",
	"activate.HasBeenEffective": "已生效",
	"activate.NotInEffect": "未生效",
	"activate.all": "全部",
	"activate.LoggedOut": "已注销",
	"activate.NotRedeemed": "未兑换",
	"activate.Redeemed": "已兑换",
	"activate.CopiedSuccessfully": "已成功复制!",
	"activate.ReplicationIsNotSupported": "不支持复制",
	"activate.TheUserDoesNotHaveActivationCodeData": "该用户没有激活码相关数据",
	"activate.ParameterError": "参数错误!",
	"activate.TheVerificationCodeHasExpiredPleaseGetTheVerificationCodeAgain": "验证码已过期，请重新获取验证码",
	"activate.TheUsersMobilePhoneNumber": "用户手机号",
	"activate.ActivationCode": "激活码",
	"activate.copy": "复制",
	"activate.RedemptionStatus": "兑换状态",
	"activate.EffectiveStatus": "生效状态",
	"activate.TheOrderNumber": "订单号",
	"activate.RedeemGoods": "兑换商品",
	"activate.RedemptionAddress": "兑换地址"
}